// src/services/queries/tokenPage/financialValueQueries.ts

import type { QueryFunction } from "@tanstack/react-query";
import { queryKeys } from "@/constants/queryKeys";
import { TIME } from "@/constants/app";
import { API_BASE_URL } from "@/services/";

import type { TokenInfoResponse, HistoricalReturnsResponse } from "@/types/tokenDashboard/financialTab";

/**
 * Fetch token basic information (name, symbol, price, founders, etc.)
 */
export const fetchTokenInfo: QueryFunction<TokenInfoResponse> = async ({
  queryKey,
}) => {
  const [, , tokenId] = queryKey;
  if (typeof tokenId !== "string") {
    throw new Error("tokenId must be a string");
  }
  const response = await fetch(
    `${API_BASE_URL}/tokenPagev2/financialValue/tokenInfo/${tokenId.toUpperCase()}`
    // `${API_BASE_URL}/tokenPage/financialValue/tokenInfo/${tokenId}`
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch token info: ${response.status}`);
  }
  return response.json();
};

/**
 * Fetch AI-generated reports for the token
 */
// Removed unused AI reports query

/**
 * Fetch key metrics (24h data)
 */
// Removed unused key metrics query

/**
 * Fetch key ratios
 */
// Removed unused key ratios query

/**
 * Fetch custom confirmations/indicators
 */
// Removed unused custom confirmations query

/**
 * Fetch historical returns data
 */
export const fetchHistoricalReturns: QueryFunction<
  HistoricalReturnsResponse
> = async ({ queryKey }) => {
  const [, , tokenId] = queryKey;
  if (typeof tokenId !== "string") {
    throw new Error("tokenId must be a string");
  }
  const response = await fetch(
    `${API_BASE_URL}/tokenPagev2/financialValue/historicalReturns/${tokenId.toUpperCase()}`
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch historical returns: ${response.status}`);
  }

  return response.json();
};

// Query options factories
export const tokenInfoQueryOptions = (tokenId: string) => ({
  queryKey: queryKeys.tokenPage.financialValue.tokenInfo(tokenId),
  queryFn: fetchTokenInfo,
  staleTime: 5 * TIME.MINUTE,
  gcTime: 10 * TIME.MINUTE, // Keep in cache for 10 minutes
  retry: 2,
});

// Removed unused aiReportsQueryOptions

// Removed unused keyMetricsQueryOptions

// Removed unused keyRatiosQueryOptions

// Removed unused customConfirmationsQueryOptions

export const historicalReturnsQueryOptions = (tokenId: string) => ({
  queryKey: queryKeys.tokenPage.financialValue.historicalReturns(tokenId),
  queryFn: fetchHistoricalReturns,
  staleTime: 5 * TIME.MINUTE,
  gcTime: 10 * TIME.MINUTE,
  retry: 2,
});
